<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="3"
        class="d-flex ml-2 justify-content-between flex-column profile-card shadow-sm"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start profile-user">
          <!-- <b-avatar
            src="../../assets/images/avatars/13.png"
            :text="avatarText(userData.lastName)"
            size="104px"
            rounded
          /> -->
          <feather-icon v-if="!userData.lastname" icon="UserIcon" size="40" class="profile-icon" />
          <div class="d-flex flex-column ml-1 text-center">
            <div class="mb-1">
              <h4 class="mb-0 profile-name">
                {{ userData.firstName }} {{ userData.lastName }}
              </h4>
              <span class="card-text profile-email" >{{ userData.email }}</span>
            </div>
            <div class="d-flex flex-wrap m-auto">
              <b-button
                :to="{ name: 'changePassword'}"
                variant="primary"
              >
                {{$t('auth.changePassword')}}
              </b-button>
              <!-- <b-button
                variant="outline-danger"
                class="ml-1"
              >
                Delete
              </b-button> -->
            </div>
          </div>
        </div>

        <!-- User Stats -->
        <!-- <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="DollarSignIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                23.3k
              </h5>
              <small>Monthly Sales</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="TrendingUpIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                $99.87k
              </h5>
              <small>Annual Profit</small>
            </div>
          </div>
        </div> -->
      </b-col>

      <!-- Right Col: Table -->
      <b-col cols="12" xl="3">
        <table class="mt-2 mt-xl-0 w-100 profile-table ml-1">
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">{{ $t("auth.username") }}</span>
            </th>
            <td class="pb-50">
              {{ userData.username }}
            </td>
          </tr>
          <!-- <tr>
            <th class="pb-50">
              <feather-icon
                icon="CheckIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Status</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.status }}
            </td>
          </tr> -->
          <tr>
            <th class="pb-50">
              <feather-icon icon="StarIcon" class="mr-75" />
              <span class="font-weight-bold">{{ $t("auth.role") }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.role }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="PhoneIcon" class="mr-75" />
              <span class="font-weight-bold">{{ $t("auth.contact") }}</span>
            </th>
            <td>
              {{ userData.mobile }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol } from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import dateFormat from "@/mixins/dateFormat";
// import useUsersList from '../users-list/useUsersList'

export default {
  mounted() {
  },
  setup() {
    // const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      // resolveUserRoleVariant,
    };
  },
  mixins: [dateFormat],
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>
